import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Text } from '@chakra-ui/react';
import { rem } from 'polished';
import { useState } from "react";
export const Rating = ({ count, onSelect, leftRatingText = "Very bad", rightRatingText = "Excellent" }) => {
    const [selectedNumber, setSelectedNumber] = useState();
    const onNumberSelect = (index) => {
        setSelectedNumber(index);
        onSelect(index + 1);
    };
    return (_jsxs(Flex, Object.assign({ flexDirection: "column" }, { children: [_jsx(Flex, Object.assign({ justifyContent: "space-between", flexWrap: "wrap", sx: {
                    marginTop: rem(32),
                    "@media (max-width: 768px)": {
                        marginTop: rem(24),
                    },
                } }, { children: Array.from(Array(count), (e, i) => {
                    return _jsx(Flex, Object.assign({ "aria-label": `btn-${i}`, sx: {
                            borderRadius: "50%",
                            borderWidth: rem(1),
                            borderStyle: "soild",
                            borderColor: "text",
                            fontSize: rem(14),
                            width: rem(40),
                            height: rem(40),
                            padding: rem(8),
                            justifyContent: "center",
                            alignItems: "center",
                            color: selectedNumber === i ? "white" : "text",
                            background: selectedNumber === i ? "text" : "transparent",
                            fontWeight: 700,
                            "@media (max-width: 768px)": {
                                width: rem(30),
                                height: rem(30),
                                padding: rem(4),
                            },
                            _hover: {
                                backgroundColor: "text",
                                color: "white",
                                cursor: "pointer"
                            }
                        }, onClick: () => onNumberSelect(i) }, { children: i + 1 }), i);
                }) })), _jsxs(Flex, Object.assign({ justifyContent: "space-between", mt: rem(8) }, { children: [_jsx(Text, Object.assign({ fontSize: rem(14), fontWeight: "700" }, { children: leftRatingText })), _jsx(Text, Object.assign({ fontSize: rem(14), fontWeight: "700" }, { children: rightRatingText }))] }))] })));
};
//# sourceMappingURL=Rating.js.map